import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { B100, B75, DN10, DN200, DN30, DN40, DN600, DN90, N0, N10, N100, N200, N30, N40, N70, N900 } from '@atlaskit/theme/colors';
export const disabledBackgroundColor = {
  light: `var(--ds-background-disabled, ${N10})`,
  dark: `var(--ds-background-disabled, ${DN10})`
};
export const defaultBackgroundColor = {
  light: `var(--ds-background-input, ${N10})`,
  dark: `var(--ds-background-input, ${DN10})`
};
export const defaultBackgroundColorFocus = {
  light: `var(--ds-background-input-pressed, ${N0})`,
  dark: `var(--ds-background-input-pressed, ${DN10})`
};
export const defaultBackgroundColorHover = {
  light: `var(--ds-background-input-hovered, ${N30})`,
  dark: `var(--ds-background-input-hovered, ${DN30})`
};
export const defaultBorderColor = {
  light: `var(--ds-border-input, ${getBooleanFF('platform.design-system-team.update-border-input_ff9l1') ? N100 : N40})`,
  dark: `var(--ds-border-input, ${getBooleanFF('platform.design-system-team.update-border-input_ff9l1') ? DN200 : DN40})`
};
export const defaultBorderColorFocus = {
  light: `var(--ds-border-focused, ${B100})`,
  dark: `var(--ds-border-focused, ${B75})`
};
export const subtleBorderColorHover = {
  light: "var(--ds-border-input, transparent)",
  dark: "var(--ds-border-input, transparent)"
};
export const transparent = {
  light: 'transparent',
  dark: 'transparent'
};
export const textColor = {
  light: `var(--ds-text, ${N900})`,
  dark: `var(--ds-text, ${DN600})`
};
export const disabledTextColor = {
  light: `var(--ds-text-disabled, ${N70})`,
  dark: `var(--ds-text-disabled, ${DN90})`
};
export const placeholderTextColor = {
  light: `var(--ds-text-subtlest, ${N200})`,
  dark: `var(--ds-text-subtlest, ${DN200})`
};